import styled, { css } from 'styled-components';
import { mq, Paper, Text } from '@wistia/vhs';
import blueSquiggle from './blue-squiggle.svg';

export const Background = styled.div<{ withBackgroundImage?: boolean; withGradient?: boolean }>`
  align-items: center;
  background-attachment: fixed;
  background-color: ${({ theme }) => theme.color.brandBlue100};
  ${({ withBackgroundImage = true }) =>
    withBackgroundImage && `background-image: url(${blueSquiggle});`};
  ${({ theme, withGradient = false }) =>
    withGradient &&
    css`
      background-image:
        radial-gradient(ellipse at 0% 0%, ${theme.color.brandBlue100}, transparent 68%),
        radial-gradient(ellipse at 0% 100%, ${theme.color.green300}, transparent 60%),
        radial-gradient(ellipse at 100% 100%, ${theme.color.brandBlue400}, transparent 74%);
    `};
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;

  ${mq.smAndDown} {
    padding: 1rem;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: 16px;
  max-width: 540px;
  padding: 4rem 5rem;

  ${mq.smAndDown} {
    padding: 2rem 2.5rem;
  }
`;

export const StyledHeader = styled(Text)`
  align-items: center;
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  margin-bottom: 16px;
  text-align: center;
`;

export const LogoContainer = styled.div`
  margin-bottom: 40px;
`;
